module.exports = __webpack_public_path__ + "img/03-medal-bronze.5e3caf5a.svg";